export var BOOKING_PLUGIN_URL = 'https://plugin.mysalononline.com/External/BookingPlugin/';